var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map"}},[_c('div',{staticClass:"wrapper"},[_c('h1',[_vm._v("ATLAS")]),_c('b-button',{staticClass:"home-button",attrs:{"variant":"outline-warning","href":"https://zqlimy.com"}},[_vm._v("Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }